//@flow

import {endpoints, sendMessage, getConversationMessages} from '../api/message';
import {buildRoute} from '../../../../http';

import {
  conversationMessageAdapter,
  mapRawToReaction,
} from '../utils/message-adapter';

import type {
  PaginationResponse,
  MessageRequest,
  MessageResponse,
  ConversationMessage,
  ReactionMessage,
} from '../../../../entities';

export const defaultPagination = {
  size: 10,
  page: 0,
};

export function sendMessageService(
  message: MessageRequest,
  conversationId: string
): Promise<void> {
  const route = buildRoute(endpoints.SEND_MESSAGE, [conversationId]);

  return sendMessage(message, {route}).toPromise();
}

type Options = {
  size?: number,
  prevToken?: string,
  nextToken?: string,
};

export async function getConversationMessagesService(
  conversationId: string,
  options: Options = {
    size: 20,
    prevToken: undefined,
    nextToken: undefined,
  }
): Promise<{
  messages: ConversationMessage[],
  reactions: ReactionMessage[],
  prevToken?: string,
  nextToken?: string,
  size: number,
}> {
  const {size = 20, prevToken, nextToken} = options;

  const route = buildRoute(endpoints.GET_CONVERSATION_MESSAGES, [
    conversationId,
  ]);

  const queryParams = {
    size: size.toString(),
  };

  if (nextToken) {
    // $FlowFixMe
    queryParams['next_token'] = nextToken;
  }

  if (prevToken) {
    // $FlowFixMe
    queryParams['prev_token'] = prevToken;
  }

  const response: PaginationResponse<MessageResponse> = await getConversationMessages(
    queryParams,
    {
      route,
    }
  ).toPromise();

  const rawMessages = response.data.filter(r => r.messageType !== 'REACTION');
  const rawReactionMessages = response.data.filter(
    r => r.messageType === 'REACTION'
  );
  // $FlowFixMe
  const messagesPromises = rawMessages.map(conversationMessageAdapter);

  const settledResults = await Promise.allSettled(messagesPromises);
  const result = settledResults
    .filter(promise => promise.status === 'fulfilled')
    .map(promise => promise.value);
  const messages = result.filter(a => a !== null);
  const nextTokenResponse = response.prevToken;
  const prevTokenResponse = response.nextToken;

  const reactions = rawReactionMessages
    .map(mapRawToReaction)
    .filter(reaction => reaction !== null);

  return {
    messages,
    reactions,
    prevToken: nextTokenResponse,
    nextToken: prevTokenResponse,
    size: response.size,
  };
}
